module.exports = __webpack_public_path__ + "static/media/1_A1_13.a544725b.png";